<template>
  <div class="ma-0 ma-sm-4">
    <v-card :loading="loading" flat class="blueCard pa-3"
      ><div
        class="d-flex flex-row flex-wrap"
        :class="isMobile ? 'justify-center text-center' : ''"
      >
        <div class="mb-2">
          <div class="d-flex flex-row flex-wrap align-start">
            <div class="mr-4">
              <div class="text-h5">Contact Lens Calculator</div>
              <div class="caption">
                Calculate GPs, Hybrids, &amp; Soft Lenses
              </div>
              <a
                href="/documentation/cl-calculator"
                target="_blank"
                class="mb-3"
                style="font-size: smaller"
              >
                Calculator Documentation
                <v-icon color="primary" x-small>mdi-open-in-new</v-icon>
              </a>
            </div>

            <!-- <a href="/documentation/cl-calculator" target="_blank">
            Calculator Documentation
            <v-icon color="primary" small>mdi-open-in-new</v-icon>
          </a> -->
          </div>
        </div>
        <v-spacer class="d-none d-sm-flex"></v-spacer>
        <div
          class="d-flex flex-column"
          :class="isMobile ? 'justify-start' : 'justify-end'"
        >
          <rx-paster
            class="my-1"
            buttonText="Parse from Text"
            buttonColor="#FFF"
            :params="['small', 'block']"
            :types="['rx', 'k']"
            :imageIcon="true"
            @pasted="pasted($event)"
          >
          </rx-paster>
          <vertex-distance-input
            class="my-1"
            @newVertexDistance="updateVertexDistance($event)"
            :params="['x-small', 'block']"
            buttonColor="#FFF"
            iconLocation="left"
          ></vertex-distance-input>
          <v-btn
            class="my-1"
            rounded
            small
            depressed
            color="#FFF"
            @click="clearForm()"
            :disabled="!canClearForm"
          >
            <v-icon color="red" class="mr-1" small>mdi-cancel</v-icon>
            Clear Form
          </v-btn>
        </div>
      </div></v-card
    >

    <div class="my-2"></div>
    <div
      class="d-flex flex-row flex-wrap justify-sm-space-around justify-lg-start"
    >
      <!-- {{ this.rxObjects }} -->
      <v-card
        v-for="eye in ['od', 'os']"
        :key="eye"
        class="mr-sm-4 pa-2 mb-4"
        :max-width="daMaxWidf"
        flat
        :class="eye + 'Background'"
        min-width="250"
      >
        <v-card-title
          :class="eye + 'HeaderBackground'"
          style="border: 1px solid #dfdfdf"
          class="d-flex flex-row flex-wrap"
          ><div>
            {{ eye | eyeText }} Eye
            <!-- {{ dirty[eye] ? "dirty!" : "clean" }} -->
          </div>
          <v-spacer></v-spacer>
        </v-card-title>
        <div
          class="d-flex flex-row flex-wrap justify-space-around justify-center"
        >
          <v-card
            class="text-center"
            :class="isMobile ? 'transparentCard_mobile' : 'transparentCard'"
            :flat="isMobile"
          >
            <div
              class="overline cardLabel d-flex flex-row align-center justify-center"
              v-if="!isMobile"
            >
              <div class="ml-2">{{ eye.toUpperCase() }} Refraction</div>
              <div style="width: 2em" class="ml-1">
                <!-- <v-fade-transition>
                  <rx-information-popup
                    v-if="rxObjects[eye]"
                    :rxObj="rxObjects[eye]"
                    class=""
                  ></rx-information-popup>
                </v-fade-transition> -->
              </div>
            </div>

            <optical-cross-image
              :dimensions="crossSize"
              :obj="rxObjects[eye]"
              type="cl"
              class="mx-auto"
              :showLens="false"
              :showEyepiece="true"
              v-if="!isMobile"
            >
            </optical-cross-image>
            <rx-input
              :eye="eye"
              :rxString="rxStrings[eye]"
              :showVertexed="true"
              :showRxCyl="true"
              :showMoreInfo="true"
              style="width: 95%"
              class="mx-auto"
              @rxChange="rxObjects[eye] = $event"
            />
          </v-card>
          <v-card
            class="text-center"
            :class="isMobile ? 'transparentCard_mobile' : 'transparentCard'"
            :flat="isMobile"
          >
            <div
              class="overline cardLabel d-flex flex-row align-center justify-center"
              v-if="!isMobile"
            >
              <div class="ml-2">{{ eye.toUpperCase() }} Keratometry</div>
              <div style="width: 2em" class="ml-1">
                <!-- <v-fade-transition>
                  <k-information-popup
                    v-if="kObjects[eye]"
                    :kObject="kObjects[eye]"
                    class=""
                  ></k-information-popup>
                </v-fade-transition> -->
              </div>
            </div>

            <optical-cross-image
              :dimensions="crossSize"
              :obj="kObjects[eye]"
              :showHeatmap="true"
              type="keratometry"
              class="mx-auto"
              v-if="!isMobile"
            >
            </optical-cross-image>
            <kerato-input
              :eye="eye"
              :kString="kStrings[eye]"
              :showConverted="true"
              :showKcyl="true"
              :showMoreInfo="true"
              style="width: 95%"
              class="mx-auto"
              @kChange="kObjects[eye] = $event"
            ></kerato-input>
          </v-card>
        </div>

        <v-card
          class="pa-3 mx-1 my-2"
          :flat="!selectedLensType[eye]"
          :color="selectedLensType[eye] ? '#FFFFFF50' : 'transparent'"
          :loading="loading"
          style="position: relative"
        >
          <div class="d-flex flex-row flex-wrap align-center">
            <div v-if="selectedLensType[eye]" class="title pr-4 mb-2">
              {{ calcOptions[selectedLensType[eye]].name }}
            </div>
            <v-spacer v-if="selectedLensType[eye]"></v-spacer>
            <cl-calc-type-picker
              :calcGroups="calcGroups"
              :calcOptions="calcOptions"
              :rxObjects="rxObjects"
              :kObjects="kObjects"
              :calcResults="calcResults"
              :selectedLensType="selectedLensType[eye]"
              :eye="eye"
              @lensType="lensTypeChange(eye, $event)"
              :class="isMobile ? 'mx-auto' : 'mr-3'"
            ></cl-calc-type-picker>

            <v-btn
              v-if="
                eye == 'os' && selectedLensType['od'] && !selectedLensType['os']
              "
              text
              color="primary"
              @click="lensTypeChange(eye, selectedLensType['od'])"
              >OS = OD</v-btn
            >
          </div>

          <div v-if="lensTypeObject[eye]" class="my-1">
            <div
              v-for="msg in cantSubmitMessages[eye]"
              :key="msg"
              class="caption red--text"
            >
              {{ msg }}
            </div>
          </div>

          <v-fade-transition>
            <div v-if="!selectedLensType[eye]" class="mx-2 mt-4">
              <strong>Need Advice?</strong>
              <ol>
                <li>Enter the refractions and keratometry</li>
                <li>Click the "Select Calculation Type" button</li>
                <li>Select "Advice" at the top of the popup window</li>
              </ol>
              <i
                >Refractions and keratometry are needed for GP and Hybrid Lens
                advice.
              </i>
            </div>
          </v-fade-transition>

          <v-scale-transition>
            <cl-calcs-result-card
              v-if="calcResultsToDisplay[eye]"
              :class="{ blurry: dirty[eye] }"
              :calcResults="calcResults"
              :lensType="selectedLensType[eye]"
              :calcOptions="calcOptions[selectedLensType[eye]]"
              :eye="eye"
              :loading="loading"
            >
              <cl-calc-verbose
                v-if="calcResultsToDisplay[eye].group != 'scls'"
                :results="calcResultsToDisplay[eye]"
                :keratometry="kObjects[eye]"
                :refraction="rxObjects[eye]"
                :class="{ 'mt-5': calcOptions[selectedLensType[eye]].hybrid }"
              ></cl-calc-verbose>
            </cl-calcs-result-card>
          </v-scale-transition>

          <div v-if="objectHasExtraFields[eye]" class="moreParamsDiv mx-0 my-3">
            <div class="caption">
              Measurements used for this calculation (change as needed):
            </div>
            <div class="d-flex flex-row align-center flex-wrap my-2">
              <div v-for="field in objectHasExtraFields[eye]" :key="field">
                <cl-calcs-field
                  :field="field"
                  :fieldOptions="fieldOptions"
                  :default="moreFieldData[eye][field]"
                  :addOptions="lensTypeObject[eye].addOptions"
                  @update="updateMoreFieldData(field, eye, $event)"
                  class="my-2 mr-4"
                ></cl-calcs-field>
              </div>
            </div>
          </div>

          <div
            v-if="
              calcResultsToDisplay[eye] &&
              calcResultsToDisplay[eye].isGoodChoiceLong
            "
            class="mt-3 discussionDiv"
          >
            <div class="overline">Discussion</div>
            <div v-html="calcResultsToDisplay[eye].isGoodChoiceLong"></div>
          </div>

          <compare-rgps
            v-if="
              calcResultsToDisplay[eye] &&
              selectedLensType[eye] == 'CLRGPSphere'
            "
            class="mt-2"
            :keratometry="kObjects[eye]"
            :lens1Power="calcResultsToDisplay[eye].fullPower"
            :lens1BC="calcResultsToDisplay[eye].fullBC"
          ></compare-rgps>
        </v-card>
      </v-card>
    </div>

    <v-card flat style="margin-top: 60px" color="#fff7e5">
      <v-card-title>Disclaimers</v-card-title>
      <v-card-text>
        <ul>
          <li>
            Lens calculations are provided as guidelines for selecting initial
            lenses. The practitioner is responsible for choosing final lens
            parameters based on their expert evaluation of lens fit and vision.
          </li>
          <li>
            All calculations assume regular corneas and anterior segment
            anatomy.
          </li>
          <li>
            Fluorescein patterns and topographies are simulated to convey
            general fitting characteristics.
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
// import RxParser from "@/components/clStuff/RxParser";
// import KeratoParser from "@/components/clStuff/KeratoParser";
import OpticalCrossImage from "@/components/clStuff/OpticalCrossImage";
import ClCalcTypePicker from "@/components/calcsStuff/ClCalcs/ClCalcTypePicker";
import ClCalcsField from "@/components/calcsStuff/ClCalcs/ClCalcsField";
import ClCalcsResultCard from "@/components/calcsStuff/ClCalcs/ClCalcsResultCard";
import ClCalcVerbose from "@/components/calcsStuff/ClCalcs/ClCalcVerbose";
import CompareRgps from "@/components/calcsStuff/ClCalcs/CompareRgps";
import RxInput from "@/components/clStuff/RxInput.vue";
import KeratoInput from "@/components/clStuff/KeratoInput.vue";
import RxPaster from "@/components/clStuff/RxPaster.vue";
import VertexDistanceInput from "@/components/calcsStuff/VertexDistanceInput.vue";

import ApiServices from "@/services/ApiServices";

export default {
  name: "ClCalcs",
  props: {},
  components: {
    // RxParser,
    // KeratoParser,
    OpticalCrossImage,
    ClCalcTypePicker,
    ClCalcsField,
    ClCalcsResultCard,
    ClCalcVerbose,
    CompareRgps,
    RxPaster,
    RxInput,
    KeratoInput,
    VertexDistanceInput,
    // RxInformationPopup: () =>
    //   import("@/components/clStuff/RxInformationPopup.vue"),
    // KInformationPopup: () =>
    //   import("@/components/clStuff/KInformationPopup.vue"),

    // HeatMap,
  },
  mixins: [
    RxMethods,
    FiltersMixin,
    // FilterDictionary
  ],
  data: function () {
    return {
      iconPath: "https://www.eyedock.com/images/menu_icons/",
      menuPath: "/clCalcs/options",
      calcPath: "/clCalcs",
      adviceDialog: false,
      adviceEye: "od",
      calcOptions: null,
      calcResults: null,
      loading: false,
      calcGroups: null,
      fieldOptions: null,
      selectedLensType: { od: null, os: null },
      vertex: 0.012,
      rxObjects: { od: null, os: null },
      kObjects: { od: null, os: null },
      desiredDiameter: { od: null, os: null },
      moreFieldData: { od: {}, os: {} },
      // just easier to make the following strings (updated with a watcher) than to try to use a computed property and make them reactive
      refractionHash: { od: "", os: "" },
      refractionHashOU: "",
      kHash: { od: "", os: "" },
      moreFieldHash: { od: "", os: "" },
      dirty: { od: false, os: false },
      rxStrings: { od: "", os: "" },
      kStrings: { od: "", os: "" },
      pauseCalcs: true,
      defaultsSet: false, // don't call doCalc before defaults are set
    };
  },
  methods: {
    clearForm() {
      this.selectedLensType = { od: null, os: null };
      this.rxObjects = { od: null, os: null };
      this.kObjects = { od: null, os: null };
    },
    pasted(event) {
      this.doPauseCalcs();
      if (event.rx) this.rxObjects = event.rx;
      if (event.ks) this.kObjects = event.ks;
      if (event.rx?.od?.add)
        this.updateMoreFieldData("add", "od", parseFloat(event.rx.od.add));
      if (event.rx?.os?.add)
        this.updateMoreFieldData("add", "os", parseFloat(event.rx.os.add));
      this.doCalc();
    },
    doPauseCalcs() {
      this.pauseCalcs = true;
      // set to false in 3 seconds
      setTimeout(() => (this.pauseCalcs = false), 1000);
    },
    lensTypeChange(eye, lensKey) {
      this.selectedLensType[eye] = lensKey;
      this.dirty[eye] = true;
      this.loading = true;
      setTimeout(() => (this.dirty[eye] = this.loading = false), 500);

      // this.doCalc();
    },
    doCalc() {
      this.loading = true;
      let path = this.calcPath + "?" + this.combinedParams;
      ApiServices.genericApiCall(path)
        .then((response) => {
          this.calcResults = response.data.results;
          this.dirty["od"] = false;
          this.dirty["os"] = false;
          console.log("docalc complete", this.rxObjects?.od?.add);
        })
        .catch((error) => {
          console.log("error", error);
          if (error)
            this.error =
              "An API error occurred whilst getting cl calcs results";
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getCalcOptions() {
      this.loading = true;
      ApiServices.genericApiCall(this.menuPath)
        .then((response) => {
          this.calcOptions = response.data.calcs;
          this.calcGroups = response.data.groups;
          this.fieldOptions = response.data.fieldOptions;
          this.setMoreFieldDefaults();
        })
        .catch((error) => {
          console.log("error", error);
          if (error)
            this.error =
              "An API error occurred whilst getting calcs menu options";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setMoreFieldDefaults() {
      // set the initial value to the default if there is one
      Object.keys(this.fieldOptions).forEach((field) => {
        let dflt = this.fieldOptions[field]?.default;

        // don't include "add1", "add2", etc in the returned parameters
        if (field.startsWith("add") && field != "add") dflt = null;
        if (dflt) {
          this.updateMoreFieldData(field, "od", dflt);
          this.updateMoreFieldData(field, "os", dflt);
        }
      });
      this.defaultsSet = true;
    },

    updateMoreFieldData(field, eye, val) {
      if (this.rxObjects[eye] && field == "add") this.rxObjects[eye].add = val;
      this.moreFieldData[eye][field] = val;
      this.moreFieldHash[eye] = this.objectToParamString(
        this.moreFieldData[eye],
        eye
      );
      this.dirty[eye] = true;
      if (this.defaultsSet && !this.pauseCalcs) this.doCalc();
    },
    keyValString(key, val, eye = null) {
      if (eye) key = key + eye.toUpperCase();
      return key + "=" + encodeURIComponent(val);
    },
    updateVertexDistance(val) {
      if (this.rxObjects["od"]) this.rxObjects["od"].vertex = val;
      if (this.rxObjects["os"]) this.rxObjects["os"].vertex = val;
    },
  },
  computed: {
    isMobile: function () {
      return this.$vuetify.breakpoint.xsOnly;
    },
    daMaxWidf: function () {
      let rtn = 555;
      if (this.$vuetify.breakpoint.name == "sm") rtn = "46.5%";
      if (this.$vuetify.breakpoint.name == "xs") rtn = "100%";
      return rtn;
    },
    selectStyle: function () {
      let style = "padding: 0 .5em; ";
      if (this.$vuetify.breakpoint.smAndUp) style += "width: 235px";
      return style;
    },
    crossSize: function () {
      return this.$vuetify.breakpoint.smAndUp ? 100 : 130;
    },

    lensTypeObject: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        const key = this.selectedLensType[eye];
        if (key) rtn[eye] = this.calcOptions[key];
      });
      return rtn;
    },
    objectHasExtraFields: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let fields = this.lensTypeObject[eye]?.requires;
        if (fields && fields.length) {
          rtn[eye] = fields;
        }
      });
      return rtn;
    },

    // canSubmit: function () {
    //   let rtn = { od: true, os: true };
    //   ["od", "os"].forEach((eye) => {
    //     if (!this.rxObjects[eye]) rtn[eye] = false;
    //     let obj = this.lensTypeObject[eye];
    //     if (!obj) {
    //       rtn[eye] = false;
    //     } else {
    //       if (obj.keratometryRequired && !this.kObjects[eye]) rtn[eye] = false;
    //       // assume required fields are all populated? They should at least be populated with default values
    //     }
    //   });
    //   return rtn;
    // },
    cantSubmitMessages: function () {
      let rtn = { od: [], os: [] };
      ["od", "os"].forEach((eye) => {
        if (!this.rxObjects[eye]) rtn[eye].push("(Refraction is required)");
        let obj = this.lensTypeObject[eye];
        if (obj && obj.keratometryRequired && !this.kObjects[eye])
          rtn[eye].push("(Keratometry is required)");
      });
      return rtn;
    },
    fieldsForLens: function () {
      let rtn = {
        od: this.lensTypeObject["od"]?.requires,
        os: this.lensTypeObject["os"]?.requires,
      };
      return rtn;
    },
    paramStringsByEye: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let eyeParams = [];
        if (this.rxObjects[eye])
          eyeParams.push(this.rxHash(this.rxObjects[eye], eye));
        if (this.kObjects[eye])
          eyeParams.push(this.keratometryHash(this.kObjects[eye], eye));
        eyeParams.push(this.moreFieldHash[eye]);
        rtn[eye] = eyeParams.join("&");
      });
      return rtn;
    },
    combinedParams: function () {
      return this.paramStringsByEye["od"] + "&" + this.paramStringsByEye["os"];
    },
    hashByEye: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let arr = [];
        if (this.refractionHash[eye]) arr.push(this.refractionHash[eye]);
        if (this.kHash[eye]) arr.push(this.kHash[eye]);
        if (this.moreFieldHash[eye]) arr.push(this.moreFieldHash[eye]);

        rtn[eye] = arr.join("&");
      });
      return rtn;
    },
    fullHash: function () {
      return this.hashByEye["od"] + "&" + this.hashByEye["os"];
    },
    calcResultsToDisplay: function () {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let selectedLensType = this.selectedLensType[eye];
        if (selectedLensType)
          rtn[eye] = this.calcResults?.[eye]?.[selectedLensType];
      });
      return rtn;
    },
    canClearForm: function () {
      let hasRx = this.rxObjects["od"] || this.rxObjects["os"];
      let hasK = this.kObjects["od"] || this.kObjects["os"];
      return hasRx || hasK;
    },
  },
  watch: {
    rxObjects: {
      handler: function (val) {
        // console.log("rxObjects watch called", val.od.add);
        ["od", "os"].forEach((eye) => {
          let currentHash = this.refractionHash[eye];
          let newHash = this.rxHash(val[eye], eye);
          if (currentHash != newHash) this.dirty[eye] = true;
          this.refractionHash[eye] = newHash;
          this.rxStrings[eye] = this.prettyString(val[eye]);
        });
        // console.log("watch add", val.od.add);

        if (this.defaultsSet && !this.pauseCalcs) {
          // console.log("rx watch docalc");
          this.doCalc();
        }
      },
      deep: true,
    },
    kObjects: {
      handler: function (val) {
        ["od", "os"].forEach((eye) => {
          let currentHash = this.kHash[eye];
          let newHash = this.keratometryHash(val[eye], eye);
          if (currentHash != newHash) this.dirty[eye] = true;
          this.kHash[eye] = newHash;
          this.kStrings[eye] = this.prettyFullKstring(val[eye]);
        });

        if (this.defaultsSet && !this.pauseCalcs) {
          // console.log("k watch docalc");
          this.doCalc();
        }
      },
      deep: true,
    },
    defaultsSet: function () {
      if (this.rxObjects.od || this.rxObjects.os) {
        // console.log("defaultsSet docalc");
        this.doCalc();
      }
    },
  },
  metaInfo() {
    return {
      title: "EyeDock/Calcs | CL Calculator",
    };
  },
  mounted() {
    this.getCalcOptions();
    this.doPauseCalcs();
    let hashParts = this.hashParts();
    let rxObjects = this.rxsFromHash(hashParts);
    if (rxObjects) this.rxObjects = rxObjects;
    let kObjects = this.keratometryFromHash(hashParts);
    if (kObjects) this.kObjects = kObjects;
    // this.pauseCalcs = false;
    // console.log("mounted docalc");
    // if (this.defaultsSet) this.doCalc();
  },
};
</script>

<style scoped>
.transparentCard {
  background-color: #ffffff3d !important;
  margin: 5px 0.5em;
  min-width: 235px;
  min-height: 275px;
}
.transparentCard_mobile {
  background-color: transparent !important;
  margin: 2px 0.5em;
  width: 100%;
  padding: 10px 0;
}
.cardLabel {
  /* font-weight: bold; */
  color: #212121;
  border-bottom: 1px solid #d4d4d4;
  background-color: #ffffff7a;
}
/* .subtle {
  font-size: 0.7rem !important;
  font-family: "Roboto", sans-serif !important;
  color: gray;
} */
.lensTypeBox {
  padding: 5px;
  border: 1px solid gray;
  border-radius: 3px;
}
.minHeight {
  min-height: 90px;
}
.moreParamsDiv {
  background-color: #f5ff793b;
  padding: 0.5em;
  margin: 0.5em;
  border-radius: 3px;
}
.discussionDiv >>> .concern {
  background-color: #ffffac;
  padding: 2px;
}
</style>
